var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProductList',{ref:"ProductList",attrs:{"format":_vm.id},on:{"update-cart":_vm.updateCart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }